// 导入所有接口
import api from './api'

let installed = false

const install = Vue => {
    if (installed)
        return;

    installed = true;
    Object.defineProperties(Vue.prototype, {
        // 注意，此处挂载在 Vue 原型的 $api 对象上
        $api: {
            get() {
                return api
            }
        }
    })
}

export default install

declare module 'vue/types/vue' {
    interface Vue {
        $api: typeof api
    }
}
